module.exports = __webpack_public_path__ + "static/machine01-a05508f679694e89da0550240d807901.png";